
import React, { useState } from 'react';
import UI from "components/UI";
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import StringUtil from 'utils/StringUtil';
import BooleanUtil from 'utils/BooleanUtil';
import UIUtils from "utils/UIUtils";
import UITextArea from "components/atoms/textarea/UITextArea";
import userStore from "common/user/store/UserStore";
import UISunEditor from "components/wysiwygeditor/UISunEditor";
import message from "common/message/source/MessageSource";

function ContentsContainer() {

	const personNm = userStore.userModel?.getPersonNm();
	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const history = useHistory();

	const [totalRowCnt,setTotalRowCnt] = useState(0);
	const [showRowCnt,setShowRowCnt] = useState(20); //기본 row count
	let totalCnt:number = 0;

	// @ts-ignore
	let destInfoItems: {RCVER_TY:string;RCVER_EMAIL_ADRES:string;RCVER_NM:string;}[] = [];		
	// @ts-ignore
	let destInfoItem: {RCVER_TY:string;RCVER_EMAIL_ADRES:string; RCVER_NM:string;} = {};


	//초기 데이터 설정
	const [destInfo, setDestInfo] = useState({});  //수신자 정보 이름과 번호 저장
	const [destInfoList, setDestInfoList] = React.useState<any[]>([]);  //수신자 정보 이름과 번호 저장

	const [emailInfo, setCEmailInfo] = useState({});
    const [emailId, setEmailId] = useState("");
	const [emailSj,setEmailSj] = useState('');   //메일제목 
	const [emailCn,setEmailCn] = useState('');   //메일내용
	const [senderEmailAdres,setSenderEmailAdres] = useState('');   //수신자 메일주소
	const [senderNm,setSenderNm] = useState('');   //발신자 메일주소
	const [rcverEmailAdres,setRcverEmailAdres] = useState('');   //수신자 메일주소
	const [rcverNm,setRcverNm] = useState('');   //수신자 메일주소
	const [recptnTy,setRecptnTy] = useState('');   //수신유형 
	const [mode, setMode] = useState('C');  //구분
    const paramMode = StringUtil.defaultString(receivedData.vMode);

	var ib = ib||{};
	ib = {
	//시트 초기화 구문
	'init':{
		"Cfg": {
			"SearchMode": 1,
			"AutoRowHeight": 1,
			"InfoRowConfig": "0",
			"Alternate":"0"
		},
		//틀고정 좌측 컬럼 설정
		"LeftCols": [
			{"Header": "No","Name": "SEQ","Width": "90"}
			],
		"Cols": [
			{"Header": "No","Type": "Int", "Name": "","Align": "Center","RelWidth": 1},
			{"Header": { "Value": "", "HeaderCheck": 1,  "IconAlign": "Center"	},"Type": "Bool","Name": "CheckData","Width": 80,"Align": "Center",	"CanEdit": 1 },
			{"Header": "수신유형(*)","Type": "Enum","Name": "RCVER_TY","Width": "100","Align": "Center","CanEdit": 1,"RawSort": 1,"Enum": "|TO|CC|BCC","EnumKeys": "|TO|CC|BCC"},
			{"Header": "수신자 메일주소(*)","Type": "Text","Name": "RCVER_EMAIL_ADRES","MinWidth": 60,"Align": "Center","CanEdit": 1,"RelWidth": 3},
			{"Header": "수신자 이름(*)","Type": "Text","Name": "RCVER_NM","MinWidth": 40,"Align": "Center","CanEdit": 1,"RelWidth": 1}
		]
	
	},
	//시트 이벤트
	'event':{
	
		onRenderFirstFinish:function (evtParam) {
			var sheet = evtParam.sheet;
			//@ts-ignore	
			sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
			
			if(paramMode == 'C'){
				rowAdd();
			}
		},
		//시트 클릭시 이벤트 처리
		onDblClick:function(evtParam){
			var sheet = evtParam.sheet;		
			CheckAllChecked(sheet , "CheckData");  //셀 선택시 체크박스 토글 
		}
		
	},
	//시트객체 생성
	'create':function () {
		let options = this.init;
	
		//@ts-ignore
		options.Events = this.event;
		//@ts-ignore
		IBSheet.create({
			id: 'sheet', // 생성할 시트의 id
			el: 'sheetDiv', // 시트를 생성할 Dom 객체 및 id
			options: options, // 생성될 시트의 속성
			data: this.data // 생성될 시트의 정적데이터
		});
		// global 변수 선언
		//@ts-ignore
		window.currentPage = -1;
	},
	//조회 데이터
	'data':[]
	}


	//행 추가
	const rowAdd = () => {
		//@ts-ignore
		sheet.addRow({ visible: 1 });
		//@ts-ignore
		sheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
		//@ts-ignore
		sheet.setValue({row:sheet.getLastVisibleRow(), col:"RCVER_TY", val:"TO", render:1});
		//@ts-ignore
		setTotalRowCnt(sheet.getDataRows().length);
	} 

	// 행 삭제
	const rowDel = () => {
		//@ts-ignore
		sheet.removeRow( sheet.getFocusedRow(), null, 1);
		//@ts-ignore
		sheet.rerender(1); //최종 수정된 내용을 화면에 반영한다.
		//@ts-ignore
		setTotalRowCnt(sheet.getDataRows().length);
	} 

	//체크 박스 체크
	function CheckAllChecked(sheet, col) {
		var row = sheet.getFocusedRow();

		var sdate = sheet.getValue( row , col );
		sheet.setCheck(row, col, 1);
	
	}

	//메일저장 및 발송 처리 ( method : create(저장) , send (직접발송) )
	async function mailCreate(method) {

		if(emailSj == null || emailSj == ''){
			await UIUtils.alert("필수항목을 입력해 주세요.");
			return;
		}

		// if(emailCn == null || emailCn == ''){
		// 	await UIUtils.alert("필수항목을 입력해 주세요.");
		// 	return;
		// }


		//@ts-ignore
		var saveJson = sheet.getSaveJson({saveMode:2});

		//console.log("getSaveJson "+ JSON.stringify(saveJson.data));
		setDestInfoList(saveJson.data); 

		//수신자 등록 정보
		await saveJson.data?.forEach(async (item, index) => {
			if((item.RCVER_EMAIL_ADRES == null || item.RCVER_EMAIL_ADRES == '') ||  (item.RCVER_NM == null || item.RCVER_NM == '') ){
				 UIUtils.alert("필수항목을 입력해 주세요.").then(()=>{
					return;
				});
			}else{
				destInfoItem = {
					RCVER_TY:item.RCVER_TY,
					RCVER_EMAIL_ADRES:item.RCVER_EMAIL_ADRES,
					RCVER_NM:item.RCVER_NM,
				}
				
				destInfoItems.push(destInfoItem);


				//저장 
				if (method === "create") {
					if (await UIUtils.confirm(message.get("admin.logmanage.emaillog.message.sendAfterSave.confirm", "DB 저장 후 스케줄러에 의해 발송됩니다.\n\n저장하시겠습니까?"))
					) {
						
						//이메일 저장
						let param = {
							"EMAIL_SEND_TYPE":'CREATE'
							,"EMAIL_SJ": emailSj
							,"EMAIL_CN": emailCn
							//,"SENDER_EMAIL_ADRES":senderEmailAdres
							,"SENDER_EMAIL_ADRES":'winfis@win-win.or.kr' //재단메일주소가 아니면 메일발송오류로 인해 메일주소로 우선 하드코딩
							,"SENDER_NM":senderNm
							,"EMAIL_DEST_INFO":destInfoItems
						};

						const response:any = await CommonUtil.execute({
							url:'adm_6120_emailSend',
							data: param,
							progressBar:true
						}).then((response: any) => {
							if(response){
								if(response.EMAIL_ID != null){
									UIUtils.alert(message.get("common.message.save.success", "저장되었습니다.")).then(()=>{

										let vEMAIL_ID = response.EMAIL_ID;
										let dataToSend = {
											vEMAIL_ID
										}
										// 다른 페이지로 이동하면서 데이터 전달
										history.push({
											pathname: './adm6110',
											state: { data: dataToSend }
										});
									});
								}
							}
						}).catch((error) => {
							CommonUtil.showAxiosError(error);
							return;
						});

					
					}
				//발송
				} else if (method === "send") {
					if (await UIUtils.confirm(message.get("admin.logmanage.emaillog.message.sendNow.confirm", "DB 저장 없이 바로 발송됩니다.\n\n발송하시겠습니까?"))) {
						
						//이메일 발송 
						let param = {
							"EMAIL_SEND_TYPE":'SEND'
							,"EMAIL_SJ": emailSj
							,"EMAIL_CN": emailCn
							//,"SENDER_EMAIL_ADRES":senderEmailAdres
							,"SENDER_EMAIL_ADRES":'winfis@win-win.or.kr'  //재단메일주소가 아니면 메일발송오류로 인해 메일주소로 우선 하드코딩
							,"SENDER_NM":senderNm
							,"EMAIL_DEST_INFO":destInfoItems
						};

						const response:any = await CommonUtil.execute({
							url:'adm_6120_emailSend',
							data: param,
							progressBar:true
						}).then((response: any) => {
							if(response){
								if(response.EMAIL_ID != null){
									UIUtils.alert(message.get("admin.logmanage.emaillog.message.send.success", "발송되었습니다.")).then(()=>{
										goList();  //목록으로
									});

									
								}
							}
						}).catch((error) => {
							CommonUtil.showAxiosError(error);
							return;
						});

						
					}
				} else {
					return;
				}
			}
		})

		

	}

	// 상세 데이터 가져오기
	async function initCall(paramMainId){
		let param = {
			"EMAIL_ID": paramMainId
		};

		const response:any = await CommonUtil.execute({
			url:'adm_6110_detail',
			data: param,
			progressBar:true
		})

		const result = response.LIST;

		//데이터 바인딩
		setCEmailInfo(result);

		setEmailId(result[0].EMAIL_ID);
		setEmailSj(result[0].EMAIL_SJ)
		setEmailCn(result[0].EMAIL_CN);
		setSenderEmailAdres(result[0].SENDER_EMAIL_ADRES);
		setSenderNm(result[0].SENDER_NM);
	
		//전체ROW개수 
		totalCnt = Object.keys(result).length;
		setTotalRowCnt(Object.keys(result).length);
			
		//데이터 처리
		ib.data = result;
		// @ts-ignore	
		sheet.loadSearchData(result);  //data 로딩 처리 

		// @ts-ignore	
		sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
	};

	//목록으로
	const goList = () => {
        history.push({
            pathname: './adm6100',
            state: {data: receivedData}
        });
    }

	// init 
	React.useEffect(() => {
		//ib시트 생성
		ib.create();
		
		if(receivedData != undefined){
			let vEmailId = StringUtil.defaultString(receivedData.vEMAIL_ID);
			let vMode = StringUtil.defaultString(receivedData.vMode);
			
			setMode(vMode);
			
			if(vMode == 'U'){
				setMode('U');
				setEmailId(vEmailId)
				//상세데이터 가지고 오기
				initCall(vEmailId);
			}
		}
	
        return () => {
          // @ts-ignore
          IBSheet.disposeAll(true);		  
		 
        }
    },[])

	return (
		<PageContainer>
			<LayoutAside />
				<div className="fww-con">

					<ul className="fww-brd">
						<li className=""><a href="">홈</a></li>
						<li className=""><a href="">관리자페이지</a></li>
						<li className=""><a href="">시스템관리</a></li>
						<li className=""><a href="">메일발송관리</a></li>
					</ul>

					<main className="fww-main">
						<h1 className="tx tx-hd2">메일 발송</h1>
						<form className="fo fo-col2 mb30" name="" action="" method="">
							<div className="inner">
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">메일제목</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={emailSj} valueChanged={(value) => setEmailSj(value)} placeholder=""/>
									</div>
								</div>
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">발송자 메일 주소</p>
									<div className="fo-value">
										{/* <UIInput className={'tf tf-md w100p'} value={senderEmailAdres} valueChanged={(value) => setSenderEmailAdres(value)} placeholder="" /> */}
										<UIInput className={'tf tf-md w100p'} value={'winfis@win-win.or.kr'} valueChanged={(value) => setSenderEmailAdres(value)} placeholder="" readOnly={true}/>
									</div>						
								</div>
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">발송자 이름</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={senderNm}  valueChanged={(value) => setSenderNm(value)} placeholder=""/>
									</div>						
								</div>		
							</div> 
						</form>					
						<div className="tb-top">
							<div>
								<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
							</div>
							<div className="hz-root hz-gap5">
								<Button color="gray-o" size="sm" onClick={rowDel}>- 삭제</Button>
								<Button color="gray-o" size="sm" onClick={rowAdd}>+ 추가</Button>
							</div>
						</div>
						<div id='sheetDiv' className='h100p'>[D] IBSHEET 영역</div>
						<br/>
											
						<div className="fo fo-col2 mb30">
							<div className="fo-item fo-m-1-3 req">
								<div className="fo-key">EMAIL 내용</div>
								<div className="fo-value">
									<div className="ta-group w100p">
										<UISunEditor value={emailCn} valueChanged={(value) => setEmailCn(value)} autoFocus ={true} />
									</div>
								</div>
							</div>
						</div>
						 

						<div className="hz-root hz-right hz-gap5 mt10">
							<Button color="pri-o" size="sm" onClick={() => mailCreate('create')}>저장</Button>
							<Button color="pri-o" size="sm" onClick={() => mailCreate('send')}>직접발송</Button>
							<Button color="pri-o" size="sm" onClick={goList}>목록</Button>
						</div>
					</main>

				</div>
		</PageContainer>
	);
}
export default ContentsContainer;